import { useHilReader } from '@bizfirst/hil-react';
import { toChatMessage } from './deriveHilChatMessages';
import type { HilChatMessage } from '../types/HilChatMessage';
import type { HilChatWindowSettings } from '../settings/HilChatWindowSettings';

/**
 * Pure derivation from the active envelope's Presentations[] (system/AI turns only —
 * does not include the user's own sent turns, which HilChatWindow tracks separately
 * since the reader has no visibility into submitted reply data). No local copy stored;
 * recomputed from the reader on every call. See deriveHilChatMessages.ts for the
 * rendering-independent mapping logic this hook wraps.
 */
export function useHilChatMessages(settings: HilChatWindowSettings): HilChatMessage[] {
  const reader = useHilReader();
  if (!reader) return [];

  const sessionID = reader.getEngageSessionID();
  const messages = reader
    .getPresentations()
    .map(presentation => toChatMessage(presentation, sessionID, reader.getActions(presentation.Order)));

  return settings.messageFilter ? messages.filter(settings.messageFilter) : messages;
}
